import { ErrorType } from '../../../models/HttpError';
import { AppState } from '../../../redux/reducers';
import { Person } from '../../../models/Entities/Person/Person';

// store
import * as PersonsStore from '../../../redux/middleware/Persons.Middleware';

export interface IProps {
  isOpen: boolean;
  openPanel: () => void;
  dismissPanel: () => void;
  personId?: number | undefined;
}

interface ConnectedProps {
  isAdding: boolean | undefined;
  successAdding: boolean | undefined;
  failAdding: boolean | undefined;
  isUpdating: boolean | undefined;
  successUpdating: boolean | undefined;
  failUpdating: boolean | undefined;
  error: ErrorType | undefined;
  person?: Person;
}

interface DispatchProps {
  CreatePerson: typeof PersonsStore.actionCreators.CreatePerson;
  UpdatePerson: typeof PersonsStore.actionCreators.UpdatePerson;
}

export type Props = IProps & ConnectedProps & DispatchProps;

export const mapStateToProps = (state: AppState, ownProps: IProps) => ({
  isAdding: state.Persons?.isAddingNewOne,
  successAdding: state.Persons?.successAddingNewOne,
  failAdding: state.Persons?.failOnAddingNewOne,
  isUpdating: state.Persons?.isUpdatingOne,
  successUpdating: state.Persons?.successUpdatingOne,
  failUpdating: state.Persons?.failOnUpdatingOne,
  error: state.Persons?.error,
  person: state.Persons?.list.find((item: Person) => item.id === ownProps.personId),
  ...ownProps
});

export const mapDispatchToProps = {
  ...PersonsStore.actionCreators
};
